import { render, staticRenderFns } from "./MyExamHistory.vue?vue&type=template&id=8e2d7b3c&scoped=true&"
import script from "./MyExamHistory.vue?vue&type=script&lang=js&"
export * from "./MyExamHistory.vue?vue&type=script&lang=js&"
import style0 from "./MyExamHistory.vue?vue&type=style&index=0&id=8e2d7b3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2d7b3c",
  null
  
)

export default component.exports